import React, {FunctionComponent, useState} from "react"
import Button from "@murphy-frontend/web-core/components/Button"
import {useResetMfa} from "@murphy-frontend/common/api/Users/Mutations"

interface ResetConfirmationProps {
	userName: string
	customerUserId: string
	closeModal: () => void
	translations: Record<string, string>
}

const ResetConfirmationBody: FunctionComponent<ResetConfirmationProps> = ({
	userName,
	closeModal,
	customerUserId,
	translations
}) => {
	const [isLoading, setIsLoading] = useState(false)
	const {mutate: resetMfa, isPending: resetMfaIsLoading} = useResetMfa(customerUserId)

	const handleReset = () => {
		setIsLoading(true)
		resetMfa(undefined, {
			onSettled: () => {
				setIsLoading(false)
				closeModal()
			}
		})
	}

	return (
		<div>
			<p className='margin-top-20'>{`${translations.resetMFAFor} ${userName}?`}</p>
			<div className='row field-add-user-btns'>
				<Button
					buttonStyle={"btn--outline"}
					isNeutralButton={true}
					buttonSize={"btn--medium"}
					onClick={closeModal}
				>
					{translations.cancel}
				</Button>
				<Button buttonSize={"btn--medium"} isLoading={isLoading} onClick={handleReset}>
					{translations.reset}
				</Button>
			</div>
		</div>
	)
}

export default ResetConfirmationBody
